export const ApiHelper = async (url, data = {}, method = "GET", customHeaders) => {
  try {
    let objtopass = {
      method: method,
      headers: {
        'appaccesstoken': process.env.REACT_APP_ACCESS_TOKEN,
        'Content-Type': 'application/json',
        ...customHeaders
      },
    };

    if (method === "POST") {
      objtopass.body = JSON.stringify(data);
    }
    let baseURL = process.env.REACT_APP_API_URL;
    // let baseURL = "http://192.168.0.211:8000/api";


    let response = await fetch(`${baseURL}${url}`, objtopass);

    const jsonResponse = await response.json();

    return jsonResponse;
  } catch (error) {
    console.error("[API Error]", error);
  }
};

export function getUserIdWithExpiry() {
  const stored = localStorage.getItem("user_id");
  if (!stored) return null;

  try {
    const data = JSON.parse(stored);
    const now = Date.now();

    if (now > data.expiry) {
      localStorage.removeItem("user_id");
      return null;
    }

    return data.value;
  } catch {
    // If parsing fails (e.g., older format), remove and return null
    localStorage.removeItem("user_id");
    return null;
  }
}

